import { FormSection } from "components/MainSectionTemplate/types";
import { YesNoRadioGroupForInPageEditing, YesNoText } from "components/ValidatedFields/YesNoRadioGroup";
import React from "react";
import { DaysAfterDateInput, DaysAfterDateText } from "./DaysAfterDateRow";

interface Props {
  instruction: server.dto.UpdateClientConfigurationInstruction
}

export const PurchaseAgreementSection = (props: Props): FormSection => {
  return {
    key: "purchaseAgreementSettings",
    type: "regular",
    title: site.currentEnvironment.purchaseAgreement.singular,
    fields: [{
      key: "purchaseAgreement_enabled",
      label: RESX.EmbedWizard.Display,
      render: () => <YesNoText value={props.instruction.purchaseAgreementEnabled} />,
      inPageEdit: {
        render: ({ onChange }) => <YesNoRadioGroupForInPageEditing
          value={props.instruction.purchaseAgreementEnabled}
          onChange={(v) => onChange(v, true)}
        />,
        type: "confirmOrCancelButton",
        initialValue: props.instruction.purchaseAgreementEnabled,
        submitChange: (value: boolean) => {
          return window.CoreApi.ClientConfiguration.Update({ ...props.instruction, purchaseAgreementEnabled: value });
        }
      }
    },
    {
      key: "purchaseAgreement_sales",
      label: RESX.Financial.Sales,
      render: () => <YesNoText value={props.instruction.purchaseAgreementDisplaySales} />,
      inPageEdit: {
        render: ({ onChange }) => <YesNoRadioGroupForInPageEditing
          value={props.instruction.purchaseAgreementDisplaySales}
          onChange={(v) => onChange(v, true)}
        />,
        type: "confirmOrCancelButton",
        initialValue: props.instruction.purchaseAgreementDisplaySales,
        submitChange: (value: boolean) => {
          return window.CoreApi.ClientConfiguration.Update({ ...props.instruction, purchaseAgreementDisplaySales: value });
        }
      }
    },
    {
      key: "purchaseAgreement_dueDate",
      label: RESX.DateTime.DueDate,
      render: () => <DaysAfterDateText days={props.instruction.purchaseAgreementDefaultDuration} type="send" />,
      inPageEdit: {
        render: ({ onChange, value, cancel }) => <DaysAfterDateInput
          value={value}
          onChange={onChange}
          maxValue={serverReference.constants.document.maxDueDateInterval}
          type="send"
          onEnter={v => onChange(v, true)}
          onEsc={cancel}
        />,
        type: "confirmOrCancelButton",
        initialValue: props.instruction.purchaseAgreementDefaultDuration,
        submitChange: (value: number) => {
          return window.CoreApi.ClientConfiguration.Update({ ...props.instruction, purchaseAgreementDefaultDuration: value });
        }
      }
    }]
  }
}